import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogFooter } from '@/Components/shadcn/dialog';
import { Button } from '@/Components/shadcn/button';
import { TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';

interface FailedToGenerateJobAdDialogProps {
    dialogTitle: string;
    message1: string;
    message2?: string;
    open: boolean;
    close: () => void;
}

function FailedToGenerateJobAdDialog({
    dialogTitle,
    message1,
    message2,
    open,
    close,
}: FailedToGenerateJobAdDialogProps): React.JSX.Element {
    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && close()}>
            <DialogContent className="max-w-md" showCloseButton={false}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <div className="flex flex-col gap-4">
                    <TypographyP className="whitespace-pre-line">{message1}</TypographyP>
                    {message2 && <TypographyP>{message2}</TypographyP>}
                </div>
                <DialogFooter className="justify-center sm:justify-center">
                    <Button onClick={close}>{UIStrings.IUnderstand}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default FailedToGenerateJobAdDialog;
